export default {
  removeBtn: {
    borderRadius: '50%',
    width: '22px',
    height: '22px',
    padding: '0px',
    marginBottom: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}


// WEBPACK FOOTER //
// ./src/common/Materials/styles.js